import type { EcommerceEventItemInput } from 'analytics/events'
import type { Cart } from 'bl-graphql/src/generated/hooks-with-types'
import { PRODUCT_IDS } from 'bl-utils/src/ProductIds'

export const formatHotelBookingToAnalyticsItems = (
  cart: Cart,
  state = undefined
): EcommerceEventItemInput[] => {
  const items = []
  for (const item of cart.items) {
    const packageCost =
      state?.packageDetails?.packageSelection?.[item?.id]?.packageCost
    const roomPrice = packageCost
      ? item?.linePrice - packageCost
      : item?.linePrice

    const discountPrice = packageCost
      ? item.discountedPrice - packageCost
      : item.discountedPrice

    const qty =
      item.productId === PRODUCT_IDS.RestaurantLava ||
      item.productId === PRODUCT_IDS.SpaRestaurant
        ? item.meta && 'noOfPersons' in item.meta
          ? Number(item.meta?.noOfPersons)
          : 1
        : item?.qty

    items.push({
      productId: item.productId,
      quantity: qty,
      price: roomPrice,
      discount: discountPrice,
    })

    if (packageCost && item.fields?.rateCode) {
      items.push({
        productId: item.fields.rateCode,
        quantity: 1,
        price: packageCost,
        discount: 0,
      })
    }
  }
  return items
}

export const formatSpaBookingToAnalyticsItems = (
  cart: Cart
): EcommerceEventItemInput[] => {
  return cart?.items.map(item => {
    const qty =
      item.productId === PRODUCT_IDS.RestaurantLava ||
      item.productId === PRODUCT_IDS.SpaRestaurant
        ? item.meta && 'noOfPersons' in item.meta
          ? Number(item.meta?.noOfPersons)
          : 1
        : item?.qty
    return {
      productId: item.productId,
      quantity: qty,
      price: item.price,
      discountedPrice: item.discountedPrice,
    } satisfies EcommerceEventItemInput
  })
}
